import { Component, OnInit } from '@angular/core';

@Component({
  template: '',
  standalone: true
})
export class EmptyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
